






import Vue from 'vue';
import {Component, Inject, Prop} from 'vue-property-decorator';

@Component
export default class TabsItem extends Vue {
  active = false;
  @Prop({type: Boolean}) disabled!: boolean;
  @Prop({type: String || Number, required: true}) name!: string | number;
  @Inject() eventBus!: Vue;

  mounted() {
    this.eventBus.$on('update:selected', (name: string) => {
      this.active = this.name === name;
      if(this.name === name)
        this.eventBus.$emit('update:headChange', this.$el)
    });
  }

  get classes() {
    return {
      active: this.active,
      disabled: this.disabled
    };
  }

  onClick() {
    if (this.disabled) {return;}
    this.eventBus.$emit('update:selected', this.name, this);
  }
}
